module.exports = __webpack_public_path__ + "static/media/cancel.cc272206.svg";